// components/DiscountSection/DiscountSection.jsx
import React, { useState } from 'react';
import { Accordion, Button, Col, Form } from 'react-bootstrap';
import { Formik, Form as Dform, Field } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { conf } from '../../confg';
import { set_discount_action, set_discount_code_action } from '../../actions/setDiscount';

const DiscountSection = ({ disabled = false, openDiscount = false, setOpenDiscount }) => {
  const dispatch = useDispatch();
  const discount = useSelector((state) => state.discount);
  // const [openDiscount, setOpenDiscount] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDiscountSubmit = async (values, { setSubmitting, resetForm }) => {
    if (!values.discountCode.trim()) return;

    setLoading(true);
    dispatch(set_discount_code_action(values.discountCode));

    try {
      const response = await axios({
        url: conf.server_url + 'coupons/' + values.discountCode,
        method: 'POST',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      dispatch(set_discount_action(response.data));

      if (response.data.success) {
        resetForm();
      }
    } catch (error) {
      console.error('Error applying discount:', error);
      dispatch(
        set_discount_action({
          success: false,
          message: 'خطا در اعمال کد تخفیف',
        }),
      );
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  const renderDiscountMessage = () => {
    if (!discount) return null;

    const messageColor = discount?.success ? 'green' : 'red';
    const message =
      discount?.message || (discount?.amount && `کد تخفیف با مبلغ ${(discount.amount / 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} تومان با موفقیت اعمال شد.`);

    return <div style={{ color: messageColor, fontSize: '13px', paddingTop: '4px' }}>{message}</div>;
  };

  return (
    <div
      id='card-discount'
      className='custom-card'
      style={{ marginBottom: '15px', backgroundColor: 'white', border: '2px solid #01494b', padding: '15px', borderRadius: '16px', marginTop: '0px' }}
    >
      <div className='card-header'>
        <Accordion.Toggle className='c-font-md font-bold accordion_toggle' as={Col}>
          <Form.Check
            className='form-check-tab'
            type='switch'
            checked={openDiscount}
            id='Discount'
            disabled={disabled}
            onChange={() => setOpenDiscount(!openDiscount)}
            label='کد تخفیف دارید؟'
          />
        </Accordion.Toggle>
      </div>

      <Accordion.Collapse in={openDiscount}>
        <div className='rtl bg-white py-4 px-2 shadow-sm'>
          <Formik initialValues={{ discountCode: '' }} onSubmit={handleDiscountSubmit} enableReinitialize>
            {({ isSubmitting }) => (
              <Dform style={{ display: 'flex' }}>
                <Field
                  style={{
                    marginLeft: '10px',
                    borderRadius: '3px',
                    border: '1px solid gray',
                    fontSize: '13px',
                    padding: '0 10px',
                    flex: 1,
                  }}
                  id='discountCode'
                  name='discountCode'
                  type='text'
                  placeholder='کد تخفیف خود را وارد کنید...'
                  disabled={loading || isSubmitting}
                />
                <Button type='submit' disabled={loading || isSubmitting}>
                  {loading || isSubmitting ? 'در حال بررسی...' : 'ثبت'}
                </Button>
              </Dform>
            )}
          </Formik>
          {renderDiscountMessage()}
        </div>
      </Accordion.Collapse>
    </div>
  );
};

export default DiscountSection;
